import React, {Component} from 'react'
import PropTypes from 'prop-types'
import timeHumanize from "../../helpers/timeHumanize"
import getLocationType from "../../../vietnameses/getLocationType"
import classNames from 'classnames'
import ButtonRemoveItem from "./ButtonRemoveItem"
import { Checkbox } from 'antd'

class RowBoxItem extends Component {
    _handleChange = (item) => {
        const {onSelected} = this.props
        const isChecked = this._detectChecked()

        if (typeof onSelected === 'function') {
            onSelected(item, !isChecked)
        }
    }

    _detectChecked = () => {
        const {item, arrSelected} = this.props

        return arrSelected.some(i => i.id === item._id)
    }

    render() {
        const {item, index, onRefresh, box, showDelete, onCheckAll} = this.props
        const {item_number, item_index, product, created, labelDetails, location_type} = item
        const {size, type} = product
        const {partnerTrackingNumber} = Object.assign({}, labelDetails)
        const isChecked = this._detectChecked()

        return (
            <tr className={classNames("RowBoxItem", location_type)}>
                {showDelete && 
                    <td>
                        <Checkbox
                            checked={isChecked}
                            onChange={() => this._handleChange(item)}
                        />
                    </td>
                }
                <td>{index + 1}</td>
                <td>
                    {showDelete &&
                        <ButtonRemoveItem 
                            onRefresh={onRefresh}
                            box={box}
                            item={item}
                            onCheckAll={onCheckAll}
                        />
                    }
                    <strong>#{item_number}_{item_index}</strong>
                </td>
                <td>{type}</td>
                <td>{size}</td>
                <td>{getLocationType(location_type)}</td>
                <td>{partnerTrackingNumber || '--'}</td>
                <td>{timeHumanize(created)}</td>
                <td>{item.shipment_status}</td>
            </tr>
        )
    }
}

RowBoxItem.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    box: PropTypes.object.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    onRefresh: PropTypes.func.isRequired,
}


export default RowBoxItem
